module.exports = {"notSupported":"Your browser is not compatible for ticket scanning. Please visit <a href='http://www.showtix4u.com/faq' target='_blank'>www.showtix4u.com/faq</a> for list of compatible browsers."}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/BarcodePicker/locales/en.json
// module id = 1393
// module chunks = 0